import React, { forwardRef } from "react";
import DatePicker from "react-datepicker";
import styles from "./date.module.css";
import Label from "../Label";
import "react-datepicker/dist/react-datepicker.css";

const CustomBox = forwardRef(({ value, onClick }, ref) => (
  <input
    className={styles.textBox}
    type="text"
    onClick={onClick}
    ref={ref}
    value={value}
  />
));

const DateInput = ({
  value,
  onChange,
  placeholder,
  name,
  label,
  inline = false,
  noBottomMargin = false,
  minDate,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: inline ? "row" : "column",
        marginBottom: noBottomMargin ? 0 : 20,
      }}
    >
      <Label name={name} text={label} />
      <DatePicker
        minDate={minDate}
        selected={value}
        onChange={(date) => onChange(date)}
        customInput={<CustomBox placeholder={placeholder} />}
      />
    </div>
  );
};

export default DateInput;
